import React from 'react';
import { pushCtaOmniEvents } from '../../../utils/PushEvents/Omniture/clickEvents';
import { CTA_TYPE } from '../../../utils/PushEvents/Omniture/utils';

const ThankyouHead = props => {
  const { thankyouInfo, isLoggedIn, bookingStatus } = props

  const { cod, txnid = '', update_obj = {}, status = 'success', pFlag, bus_post_booking_cashback, bus_post_travel_gocash_amount } = thankyouInfo;
  const { email = '', mobile, bid } = update_obj;

  const ctaeventhelper = () => {
    pushCtaOmniEvents('My Booking', CTA_TYPE.HYPER_LINK, 'My Booking HYPERLINK', 'https://www.goibibo.com/travelhistory'); 
    setTimeout(() => location.href="/travelhistory/", 500) 
  }

  if (bookingStatus && bookingStatus.toLowerCase() == 'cancel') {
    return null;
  }
  return (
    <>
      {status == 'partial' ?
        <div className="thkContHdr tu_partial marginB20 marginT10">
          <div className="col-md-12 col-sm-12 row">
            {/* <span className="commonSprite timeStamp fl posRel marginR15 marginB15 mobtimeStampPos mobdn">
                           <span className="timePos">
                               <div className="fl marginL20 padL20 padT1 squareloader loaderPos timeLoader">
                                 <div className="loader">Loading…</div>
                               </div>

                               <div className="clearfix dn odometer">
                                  <div className="fl">
                                        <div className="digit digOne"></div>
                                        <div className="ico14 blue padL2 fb">m</div>
                                  </div>
                                  <div className="fl">
                                        <div className="digit digTwo"></div>
                                        <div className="ico14 blue padL2 fb">m</div>
                                  </div>
                                  <div className="dib fl ico17 blue fb padR2">:</div>
                                  <div className="fl">
                                        <div className="digit digThree"></div>
                                        <div className="ico14 blue padL5 fb">s</div>
                                  </div>
                                  <div className="fl">
                                        <div className="digit digFour"></div>
                                        <div className="ico14 blue padL5 fb">s</div>
                                  </div>
                                 </div>
                             <small className="db ico11 grey txtCenter"></small>
                           </span>
                         </span> */}
            <div className="thkContHdrTxt">
              {!cod ?
                <>
                  <h3 className="blue lh1-5 headSet">Your cash on delivery request went through successfully.</h3>
                  <p className="marginT20 ico15 fl lh1-5 width100">{`Further details of your ticket delivery will be communicated through SMS. The tracking number for your request is: `}
                    <strong>{txnid}</strong>
                    {` In case you have any queries, please contact our customer support and quote the tracking number for assistance.`}</p>

                </> :

                <>
                  <h3 className="blue lh1-5 headSet">Great, your payment went through successfully</h3>
                  <p className="ico14 greyLt lh1-5">Thank you for choosing goibibo. We're confirming your ticket with bus operator.</p>
                  <p className="marginT20 ico15 fl lh1-5 width100">
                    <i className="icon-reverse-tick green ico20 padR5 padT2 fl"></i>
                    <span className="bkngId">
                      {email ? <>{`We will email final confirmation and E-Ticket to `}
                        <span style={{ color: "#166bd3" }}>{email}</span>
                        {` in a short while. You will also receive an SMS at `}
                        <strong>{mobile}</strong>
                        {'.'}
                      </>
                        :
                        <>
                          {`We have sent an SMS with all booking details and E-ticket to you at `}
                          <strong>{mobile}</strong>
                          {`. Use this bookingid `}
                          <strong>{txnid}</strong>{` in all communication with goibibo.`}
                        </>}
                    </span>
                  </p>
                  {isLoggedIn ?
                    <p className="marginT20 ico15 fl lh1-5 width100"><i className="icon-reverse-tick green ico20 padR5 padT2 fl"></i>
                      {`You can also check your ticket status under`}
                      <a onClick={ () => ctaeventhelper()}>
                        {` My Booking.`}
                      </a>
                      {`It might take longer than expected in some cases.`}
                    </p>
                    : null}
                </>}
            </div>

          </div>
        </div> : null}
      {bookingStatus && bookingStatus.toLowerCase() == 'confirmed' ?
        <div className="thkContHdr tu_success marginB20 marginT10">
          <div className="col-md-12 col-sm-12 row">
            {/* <span className="commonSprite timeStamp fl posRel marginR15 marginB15 mobtimeStampPos mobdn">
                             <span className="timePos">
                                 <div className="fl marginL20 padL20 padT1 squareloader loaderPos timeLoader">
                                   <div className="loader">Loading…</div>
                                 </div>

                                 <div className="clearfix odometer">
                                  <div className="fl">
                                        <div className="digit digOne"></div>
                                        <div className="ico14 blue padL2 fb">m</div>
                                  </div>
                                  <div className="fl">
                                        <div className="digit digTwo"></div>
                                        <div className="ico14 blue padL2 fb">m</div>
                                  </div>
                                  <div className="dib fl ico17 blue fb padR2">:</div>
                                  <div className="fl">
                                        <div className="digit digThree"></div>
                                        <div className="ico14 blue padL5 fb">s</div>
                                  </div>
                                  <div className="fl">
                                        <div className="digit digFour"></div>
                                        <div className="ico14 blue padL5 fb">s</div>
                                  </div>
                                 </div>
                               <small className="db ico11 grey txtCenter"></small>
                             </span>
                           </span> */}
            <div className="thkContHdrTxt">
              {cod ?
                <>
                  <h3 className="blue lh1-5 headSet">Your request went through successfully</h3>
                  <p className="ico14 greyLt lh1-5">{`You will receive a call from our team shortly. Please note that the ticket will be confirmed only after the telecon. The tracking number for your request is `}
                    <strong>{txnid}</strong>
                    {`. In case you do not get a call from us or have a any queries, please contact us and  quote the tracking number for assistance.`}</p>
                </>
                :
                <>
                  <h3 className="blue lh1-5 headSet">Great, your booking went through successfully</h3>
                  <p className="ico14 greyLt lh1-5">Thank you for choosing goibibo.</p>
                  <p className="marginT20 ico15 fl lh1-5 width100">
                    <i className="icon-reverse-tick green ico20 padR5 padT2 fl"></i>
                    <span className="bkngId">
                      {email ?
                        <>
                          {`We have emailed all the details and the E-tickets to you @`}
                          <span style={{ color: "#166bd3" }}>{email}</span>
                          {`. You will also receive an SMS at `}
                          <strong>{mobile}</strong>
                          {'.'}
                        </>
                        :
                        <>

                          {` We have sent an SMS with all booking details and E-ticket to you at `}
                          <strong>{mobile}</strong>
                          {`. Use this bookingid `}
                          <strong>{txnid}</strong>
                          {` in all communication with goibibo.`}
                        </>}
                    </span>

                  </p>
                </>}
              {bus_post_booking_cashback ?
                <div className="col-md-12 col-sm-12 col-xs-12 pad0 marginT20">
                  <div className="travelbenefitsWrap">
                    <div className="col-md-1 col-sm-2 col-xs-3 pad5 txtCenter">
                      <img src="/styleguide/images/sunburnrupee.png" width="46px" height="46px;" />
                    </div>
                    <div className="col-md-11 col-sm-10 col-xs-9 pad5">
                      <p className="ico14 padT15 lh1-2"> Congratulations! <i className="icon-rupee ico10"></i>
                        <strong>{bus_post_travel_gocash_amount}</strong>
                        {` goCash cashback will be credited to your wallet post travel.`}</p>
                    </div>
                  </div>
                </div> : null}

              {isLoggedIn ?
                <p className="marginT20 ico15 fl lh1-5 width100">
                  <i className="icon-reverse-tick green ico20 padR5 padT2 fl"></i>
                  {`You can also check your ticket status under`}
                  <a onClick={ () => {ctaeventhelper()}}>
                    {` My Booking.`}
                  </a>
                </p>
                : null}


            </div>
          </div>
        </div> : null}

      {bookingStatus && bookingStatus.toLowerCase() == 'processing' ?

        <div className="thkContHdr tu_error marginB20 marginT10">
          <div className="fl greyLter ico50 marginT20 padLR20 marginLR20 mobdn">
            <span className="fl">:</span>
            <span className="fl">-</span>
            <span className="fl">(</span>
          </div>
          <div className="thkContHdrTxt">
            <h3 className="blue lh1-5 headSet">Aww... your booking didn't go through</h3>
            <span className="bkngId">

              <>
                {`Dear Customer, your payment has been debited but your booking is still under process for confirmation with the bus operator, please wait for 15 minutes while we confirm your seat. Our customer care team will assist you shortly with more details. For any other issues you can contact us at`}
                <span style={{ color: "#166bd3" }}>{` travel@goibibo.com.`}</span>

                {` Your booking reference ID is `}
                <strong>{txnid}</strong>{` , Kindly refer to this ID in all communication with Goibibo.`}
              </>
            </span>
          </div>
        </div>
        : null
      }

      {!bookingStatus ?
        <div className="thkContHdr tu_success marginB20 marginT10">
          <div className="col-md-12 col-sm-12 row">

            <div className="thkContHdrTxt">
              {cod ?
                <>
                  <h3 className="blue lh1-5 headSet">Your request went through successfully</h3>
                  <p className="ico14 greyLt lh1-5">{`You will receive a call from our team shortly. Please note that the ticket will be confirmed only after the telecon. The tracking number for your request is `}
                    <strong>{txnid}</strong>
                    {`. In case you do not get a call from us or have a any queries, please contact us and  quote the tracking number for assistance.`}</p>
                </>
                :
                <>
                  <h3 className="blue lh1-5 headSet">Great, your payment went through successfully</h3>
                  <p className="ico14 greyLt lh1-5">Thank you for choosing goibibo.</p>
                  <p className="marginT20 ico15 fl lh1-5 width100">
                    <i className="icon-reverse-tick green ico20 padR5 padT2 fl"></i>
                    <span className="bkngId">
                      {email ?
                        <>
                          {`We have emailed all the details and the E-tickets to you @`}
                          <span style={{ color: "#166bd3" }}>{email}</span>
                          {`. You will also receive an SMS at `}
                          <strong>{mobile}</strong>
                          {'.'}
                        </>
                        :
                        <>

                          {` We have sent an SMS with all booking details and E-ticket to you at `}
                          <strong>{mobile}</strong>
                          {`. Use this bookingid `}
                          <strong>{txnid}</strong>
                          {` in all communication with goibibo.`}
                        </>}
                    </span>

                  </p>
                </>}
              {bus_post_booking_cashback ?
                <div className="col-md-12 col-sm-12 col-xs-12 pad0 marginT20">
                  <div className="travelbenefitsWrap">
                    <div className="col-md-1 col-sm-2 col-xs-3 pad5 txtCenter">
                      <img src="/styleguide/images/sunburnrupee.png" width="46px" height="46px;" />
                    </div>
                    <div className="col-md-11 col-sm-10 col-xs-9 pad5">
                      <p className="ico14 padT15 lh1-2"> Congratulations! <i className="icon-rupee ico10"></i>
                        <strong>{bus_post_travel_gocash_amount}</strong>
                        {` goCash cashback will be credited to your wallet post travel.`}</p>
                    </div>
                  </div>
                </div> : null}

              {!isLoggedIn ?
                <p className="marginT20 ico15 fl lh1-5 width100">
                  <i className="icon-reverse-tick green ico20 padR5 padT2 fl"></i>
                  {`You can also check your ticket status under`}
                  <a onClick={ () => {ctaeventhelper()}}>
                    {` My Booking.`}
                  </a>
                  {`It might take longer than expected in some cases.`}
                </p>
                : null}
            </div>
          </div>
        </div> : null}
    </>
  )
}
export default ThankyouHead;
